var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_802_2099",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 21,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.96036 10.6112C2.73932 10.6112 2.52734 10.5234 2.37105 10.3671C2.21476 10.2108 2.12695 9.9988 2.12695 9.77777V3.11221C2.12695 2.89118 2.21476 2.6792 2.37105 2.52291C2.52734 2.36661 2.73932 2.27881 2.96036 2.27881H9.62758C9.84861 2.27881 10.0606 2.36661 10.2169 2.52291C10.3732 2.6792 10.461 2.89118 10.461 3.11221V9.77777C10.461 9.9988 10.3732 10.2108 10.2169 10.3671C10.0606 10.5234 9.84861 10.6112 9.62758 10.6112H2.96036ZM14.628 10.6112C14.407 10.6112 14.195 10.5234 14.0387 10.3671C13.8824 10.2108 13.7946 9.9988 13.7946 9.77777V3.11221C13.7946 2.89118 13.8824 2.6792 14.0387 2.52291C14.195 2.36661 14.407 2.27881 14.628 2.27881H21.2936C21.5146 2.27881 21.7266 2.36661 21.8829 2.52291C22.0391 2.6792 22.127 2.89118 22.127 3.11221V9.77777C22.127 9.9988 22.0391 10.2108 21.8829 10.3671C21.7266 10.5234 21.5146 10.6112 21.2936 10.6112H14.628ZM2.96036 22.2788C2.73932 22.2788 2.52734 22.191 2.37105 22.0347C2.21476 21.8784 2.12695 21.6664 2.12695 21.4454V14.7782C2.12695 14.5572 2.21476 14.3452 2.37105 14.1889C2.52734 14.0326 2.73932 13.9448 2.96036 13.9448H9.62758C9.84861 13.9448 10.0606 14.0326 10.2169 14.1889C10.3732 14.3452 10.461 14.5572 10.461 14.7782V21.4454C10.461 21.6664 10.3732 21.8784 10.2169 22.0347C10.0606 22.191 9.84861 22.2788 9.62758 22.2788H2.96036ZM14.628 22.2788C14.407 22.2788 14.195 22.191 14.0387 22.0347C13.8824 21.8784 13.7946 21.6664 13.7946 21.4454V14.7782C13.7946 14.5572 13.8824 14.3452 14.0387 14.1889C14.195 14.0326 14.407 13.9448 14.628 13.9448H21.2936C21.5146 13.9448 21.7266 14.0326 21.8829 14.1889C22.0391 14.3452 22.127 14.5572 22.127 14.7782V21.4454C22.127 21.6664 22.0391 21.8784 21.8829 22.0347C21.7266 22.191 21.5146 22.2788 21.2936 22.2788H14.628Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_802_2099)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.126953,
    y: 0.277832,
    width: 24,
    height: 24,
    fill: "#1F2024"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrActive);
export default __webpack_public_path__ + "static/media/qrActive.26a17968f35472addb0298d026e0e7c5.svg";
export { ForwardRef as ReactComponent };